import { courseActions } from './CourseActions';

const initState = {
    loadingFlags: {
        "course": true,
    },
    error: null,
    breadCrumbItems: [],
    accesses: {
        accessFrom: false,
        accessExecute: false,
        accessOverview: false,
    },
    unSeenMessages: 0,
    notifList: [],
    notifsCount: 0,
    showNotifsList: false
}

export default function profilePageReducer(state=initState, action) {
    switch (action.type) {
        case courseActions.setBreadCrumb:
            return setBreadCrumb(state, action);
        case courseActions.setError:
            return setError(state, action);
        case courseActions.toggleSpinner:
            return toggleSpinner(state, action);
        case courseActions.setAccess:
            return setAccess(state, action);
        case courseActions.setUnSeenMessages:
            return setUnSeenMessages(state, action);
        case courseActions.setNotifList:
            return setNotifList(state, action);
        case courseActions.setNotifsCount:
            return setNotifsCount(state, action);
        case courseActions.toggleNotifsList:
            return toggleNotifsList(state, action);
        case courseActions.hideNotifsList:
            return hideNotifsList(state);
        default:
            return state;
    }
}

function setAccess(state, { payload }) {
    return {
        ...state,
        accesses: payload,
    }
}

function setBreadCrumb(state, {payload}) {
    return {
        ...state, 
        breadCrumbItems: payload
    }
}

function setError(state, {payload}) {
    return {
        ...state,
        error: payload,
    }
}

function toggleSpinner(state, {payload, meta}) {
    return {
        ...state,
        loadingFlags: {
            ...state.showSpinner,
            [meta.apiName]: payload
        },
    }
}

function toggleNotifsList(state, { payload }) {
    return {
        ...state,
        showNotifsList: payload
    }
}

function hideNotifsList(state) {
    return {
        ...state,
        showNotifsList: false
    }
}

function setUnSeenMessages(state, { payload }) {
    return {
        ...state,
        unSeenMessages: payload
    }
}

function setNotifList(state, { payload }) {
    return {
        ...state,
        notifList: payload
    }
}


function setNotifsCount(state, { payload }) {
    return {
        ...state,
        notifsCount: payload
    }
}